
const customTheme = {
    token: {
        fontFamily: 'Cinzel',
    }
};

export default customTheme;